import { BaseRepository } from '@/base/base-repository';
import { CAMPAIGN_CFG } from '@/configs/campaign-config';

export interface CampaignTicketSummary {
	totalWagered: number;
	lastUpdated?: string;
}

class CampaignRepository extends BaseRepository {
	async getTicketSummary({ address, start, end }: { address: string; start: string; end: string }): Promise<CampaignTicketSummary> {
		const path = CAMPAIGN_CFG.ticketing.apiPath;
		try {
			const response = await this.httpClient({
				method: 'get',
				url: path,
				params: {
					address,
					start,
					end,
				},
			});
			const totalWageredRaw = response?.totalWagered ?? response?.total_wagered ?? 0;
			const lastUpdatedRaw = response?.lastUpdated ?? response?.last_updated ?? undefined;
			return {
				totalWagered: Number(totalWageredRaw ?? 0),
				lastUpdated: lastUpdatedRaw != null ? String(lastUpdatedRaw) : undefined,
			};
		} catch (error) {
			console.warn('Failed to fetch campaign ticket summary', { path, address, error });
			return { totalWagered: 0 };
		}
	}
}

export const campaignRepository = new CampaignRepository();
